import { Radio as RadioAnt } from 'antd'
import { themeColor, themeFontFamily } from 'LibNeo/theme'
import styled, { css } from 'styled-components'
import { IconComponent, Text } from 'LibNeo'

export const RadioWrapper = styled.div``

export const RadioStyle = styled(RadioAnt.Group)<{
	fullwidth?: boolean
	vertical?: boolean
	horizontal?: boolean
}>`
	display: inline-flex;
	align-items: flex-start;
	font-family: ${themeFontFamily('SBSansInterface')};
	font-weight: normal;
	.ant-radio.ant-radio-checked {
		.ant-radio-inner {
			background-color: ${themeColor('emerald', 5)};
			outline-color: ${themeColor('emerald', 5)};
		}
	}
	.ant-radio {
		height: 20px;
		width: 20px;
		+ span {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			padding: 0;
		}
		.ant-radio-inner {
			margin: 1px;
			width: 18px;
			height: 18px;
			outline: 1px solid ${themeColor('gray', 3)};
			border: 4px solid transparent;
			background-color: transparent;
			background-clip: content-box;
			border-radius: 50%;
			&::after {
				content: none;
			}
		}
		.ant-radio-input {
			&:focus {
				+ .ant-radio-inner {
					box-shadow: none;
				}
			}
		}

		&.ant-radio-disabled {
			cursor: not-allowed;

			&.ant-radio-checked {
				.ant-radio-inner {
					background-color: ${themeColor('emerald', 3)};
					outline-color: ${themeColor('emerald', 3)}!important;
				}
			}
			.ant-radio-inner {
				border-color: ${themeColor('gray', 1)} !important;
				background-color: ${themeColor('gray', 1)};
			}
		}
	}
	.ant-radio-wrapper {
		display: inline-flex;
		margin-right: 0;
		border-radius: 4px;
		min-width: 120px;
		&:not(.ant-radio-wrapper-disabled):hover {
			.ant-radio-input:not(:focus) + .ant-radio-inner {
				outline: 1px solid ${themeColor('gray', 5)};
			}
			.ant-radio.ant-radio-checked {
				.ant-radio-inner {
					background-color: ${themeColor('emerald', 7)};
					outline-color: ${themeColor('emerald', 7)};
				}
			}
			.ant-radio.ant-radio-checked.ant-radio-disabled {
				.ant-radio-inner {
					background-color: ${themeColor('emerald', 3)};
					border-color: transparent !important;
					outline-color: ${themeColor('emerald', 3)};
				}
			}
		}
	}

	.ant-radio-input:focus + .ant-radio-inner {
		outline-color: ${themeColor('emerald', 5)};
	}

	.ant-radio-checked:hover .ant-radio-inner,
	.ant-radio-checked .ant-radio-input:focus + .ant-radio-inner {
		outline-color: ${themeColor('emerald', 6)};
		background-color: ${themeColor('emerald', 6)};
	}

	${({ fullwidth }) =>
		fullwidth &&
		css`
			display: flex;
			justify-content: space-between;
		`}

	${({ vertical }) =>
		vertical &&
		css`
			flex-direction: column;
			${RadioWrapper} + ${RadioWrapper} {
				margin-top: 16px;
			}
		`}

    ${({ horizontal }) =>
		horizontal &&
		css`
			min-width: 100%;
			margin: -6px -12px;
			${RadioWrapper} {
				flex: 1;
				margin: 6px 12px;
			}
		`}
`

export const RadioLabel = styled.p<{
	disabled: boolean
}>`
	font-size: 14px;
	line-height: 20px;
	font-weight: 400;
	color: ${themeColor('gray', 8)};
	padding: 0 0 0 12px;
	white-space: normal;
	margin: 0;
	user-select: none;
	${({ disabled }) =>
		disabled &&
		css`
			cursor: not-allowed;
			color: ${themeColor('gray', 5)};
		`}
`

export const RadioTooltip = styled.div`
	display: inline-flex;
`
export const Icon = styled(IconComponent)`
	margin: 0 0 0 4px;
	padding-top: 1px;
`

export const RadioCaption = styled(Text)`
	padding-left: 32px;
`
